var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 66,
    viewBox: "0 0 75 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2014 44.2326C11.375 42.0234 10.064 37.1307 12.2732 33.3044L29.0732 4.20593C31.2823 0.379588 36.175 -0.931417 40.0014 1.27772C43.8277 3.48686 45.1387 8.37958 42.9296 12.2059L26.1296 41.3044C23.9204 45.1307 19.0277 46.4417 15.2014 44.2326ZM1.07313 52.7033C-1.13601 56.5297 0.174998 61.4224 4.00134 63.6315C7.82768 65.8407 12.7204 64.5297 14.9296 60.7033C17.1387 56.877 15.8277 51.9843 12.0014 49.7751C8.17501 47.566 3.28227 48.877 1.07313 52.7033ZM59.8138 53.3619C57.6047 57.1883 58.9157 62.081 62.742 64.2901C66.5684 66.4993 71.4611 65.1883 73.6702 61.3619C75.8794 57.5356 74.5684 52.6429 70.742 50.4337C66.9157 48.2246 62.023 49.5356 59.8138 53.3619ZM31.245 51.6467C29.0359 55.473 30.3469 60.3658 34.1733 62.5749C37.9996 64.784 42.8923 63.473 45.1015 59.6467L57.9015 37.4765C60.1106 33.6501 58.7996 28.7574 54.9733 26.5482C51.1469 24.3391 46.2542 25.6501 44.0451 29.4765L31.245 51.6467Z",
    fill: "url(#paint0_linear_157_1908)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_1908",
    x1: 75.3719,
    y1: 63.6546,
    x2: 17.7719,
    y2: 24.4546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E41C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880688,
    stopColor: "#F80090"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d2a9ee013203f8f2e97262a893023631.svg";
export { ForwardRef as ReactComponent };